module.exports = __webpack_public_path__ + "img/icon-right@2x.fb1e3938.png";